import * as React from "react"
import style from "./PrimaryButton.module.scss"
import classnames from "classnames"
interface PrimaryButtonProps
  extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  isLoading?: boolean
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({ className, children, disabled, isLoading, ...props }) => {
  return (
    <button disabled={isLoading || disabled} className={classnames(style.button, style.ripple, className)} {...props}>
      {children}
    </button>
  )
}

export default PrimaryButton
